<template>
  <div
    class="file-upload"
    :class="{ 'file-upload--sm': isSmall }"
  >
    <v-icon
      v-if="!isSmall"
      class="file-upload__icon"
      type="document"
    />
    <div class="file-upload__content">
      <span class="file-upload__name">{{ fileName }}</span>
      <template v-if="fileSize">
        {{ fileSize }}
      </template>
    </div>
    <v-cancel
      class="file-upload__cancel"
      :is-light="isSmall"
      @click="$emit('clear')"
    />
  </div>
</template>

<script>
import Icon from "@/atoms/Icon";
import Cancel from "@/atoms/Cancel";
export default {
	components: {
		"v-cancel": Cancel,
		"v-icon": Icon,
	},
	props: {
		fileName: {
			type: String,
			default: "Document"
		},
		fileSize: {
			type: String,
			default: null
		},
    isSmall: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.file-upload {
    $this: &;
		position: relative;
		display: flex;
    align-items: center;
    text-align: left;
    &__content {
      flex: 1;
    }
		&__name {
      font-weight: $font-weight-bold;
			display: inline-block;
			margin-right: 5px;
		}
		&__icon {
			font-size: 2rem;
      line-height: 1;
      margin-right: .5rem;
		}
    &--sm {
      display: inline-flex;
      font-size: $font-size-sm;
      background-color: $primary;
      color: $white;
      border-radius: 1rem;
      padding: .25em .5em;
      #{$this}__name {
        font-weight: $font-weight-bold;
      }
      & + & {
        margin-left: .5em;
      }
    }
	}
</style>
